import { forwardRef, type ComponentProps } from 'react';
import { Input } from '@/components/ui/input';
import { maskCep, maskCnpj, maskCpf, maskMoney, maskPhone } from '@/lib/format';

const masks = { cpf: maskCpf, cnpj: maskCnpj, cep: maskCep, phone: maskPhone, money: maskMoney };

/** Input com máscara aplicada no onChange; funciona com `register` (uncontrolled). */
export const MaskedInput = forwardRef<HTMLInputElement, ComponentProps<typeof Input> & { mask: keyof typeof masks }>(
  ({ mask, onChange, ...props }, ref) => (
    <Input
      ref={ref}
      inputMode={mask === 'money' || mask === 'cep' || mask === 'cpf' || mask === 'cnpj' || mask === 'phone' ? 'numeric' : undefined}
      {...props}
      onChange={(e) => {
        e.target.value = masks[mask](e.target.value);
        onChange?.(e);
      }}
    />
  ),
);
MaskedInput.displayName = 'MaskedInput';
